import { render, staticRenderFns } from "./quality-assurance-ws-info.vue?vue&type=template&id=69c9a824&scoped=true&"
import script from "./quality-assurance-ws-info.vue?vue&type=script&lang=js&"
export * from "./quality-assurance-ws-info.vue?vue&type=script&lang=js&"
import style0 from "./quality-assurance-ws-info.vue?vue&type=style&index=0&id=69c9a824&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c9a824",
  null
  
)

export default component.exports